import { Component, Input, Output, EventEmitter } from "@angular/core";

import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";
import "rxjs/add/operator/do";
import "rxjs/add/operator/map";
import "rxjs/add/operator/switchMap";
import "rxjs/add/operator/merge";
import {
  NgbModal,
  NgbModalOptions,
  ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";
// import * as $ from 'jquery';

@Component({
  selector: "searchchildmodal",
  moduleId: module.id,
  templateUrl: "searchchildmodal.component.html",
})
export class SearchChildModal {
  @Input() nest?: any;
  @Input() eventMeshutaf?: any;
  @Input() inline?: boolean;
  @Output() childSelected?: EventEmitter<any> = new EventEmitter();
  model: any;
  modalReference: any;
  searching: boolean;
  searchFailed: boolean;
  messages: any;
  hideSearchingWhenUnsubscribed = new Observable(
    () => () => (this.searching = false)
  );

  constructor(
    private modalService: NgbModal,
    private dataService: DataService,
    private alertService: AlertService
  ) {
    this.searching = false;
    this.messages = JSON.parse(localStorage.getItem("messages"));
  }

  public formatter = (child: { firstName: string; lastName: string }) =>
    child.firstName +
    (child.firstName &&
    child.firstName != "" &&
    child.lastName &&
    child.lastName != ""
      ? " "
      : "") +
    child.lastName;

  open(content) {
    this.clearSearch();
    let options: NgbModalOptions = {
      windowClass: "modal-opened searchChild",
    };
    this.modalReference = this.modalService.open(content, options);
  }

  searchChild() {}

  clearSearch() {
    setTimeout(() => {
      this.model = { firstName: "", lastName: "" };
    }, 700);
    if (this.modalReference) this.modalReference.close();
  }

  selectRow(child) {}

  select(event) {
    let child = event.item;
    this.clearSearch();
    if (this.eventMeshutaf) {
      this.dataService
        .addChildMeshutaf({ event: this.eventMeshutaf, child: child })
        .subscribe(
          (data) => {},
          (error) => {
            let body = error.json && error.json();
            this.alertService.error(
              body && body.statusText
                ? this.messages[body.statusText]
                  ? this.messages[body.statusText]
                  : decodeURIComponent(body.statusText)
                : (error && error.statusText) || error
            );
          }
        );
    } else if (this.childSelected) {
      this.model = undefined;
      this.childSelected.emit(child);
    } else {
      this.dataService.getUsersData(child.id).subscribe();
    }
  }

  search = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .do(() => (this.searching = true))
      .switchMap((term) =>
        this.dataService
          .searchChild(term)
          .do(() => (this.searchFailed = false))
          .catch(() => {
            this.searchFailed = true;
            return of([]);
          })
      )
      .do(() => (this.searching = false))
      .merge(this.hideSearchingWhenUnsubscribed);

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/child/searchchildmodal.component.ts